module.exports = __webpack_public_path__ + "images/corners/Rectangle.bd9eb8b2398f39cf2a569ea60084f0c4.jpg";